import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";

const defaultForm = {
  nameDisability: "",
};

const FormDiscapacidades = ({ crear, data, editar }) => {
  const history = useHistory();
  const [form] = useState(defaultForm);
  const [modal, setModal] = useState(false);

  const FormSchema = Yup.object().shape({
    nameDisability: Yup.string()
      .min(3, "Nombre debe contener al menos 3 letras")
      .max(100, "Nombre debe contener menos 100 caracteres")
      .required("Ingrese el nombre de la discapacidad"),
  });

  const submitFunction = (fields) => {
    setModal(true);
  };
  const cancelOp = () => {
    history.push("/template/discapacidades");
  };

  return (
    <Formik
      initialValues={form}
      validationSchema={FormSchema}
      onSubmit={(fields) => {
        submitFunction(fields);
      }}
      onReset={(fields, { resetForm }) => {
        cancelOp();
      }}
    >
      {({ errors, status, touched, values }) => (
        <Form>
          <ModalConfirmation
            modalTitle={data ? "Editar" : "Crear"}
            modal={modal}
            setModal={setModal}
            crear={crear}
            editar={editar}
            isEdit={data ? true : false}
            values={values}
          >
            {data ? (
              <div className="d-flex justify-content-center">
                <h6>¿Está seguro de editar el registro?</h6>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <h6>¿Desea continuar con el registro?</h6>
              </div>
            )}
          </ModalConfirmation>
          <div className="form-group">
            <label htmlFor="nameDisability">
              Nombre de la discapacidad<span className="text-danger">*</span>
            </label>
            <Field
              name="nameDisability"
              type="text"
              placaceholder="Nombre del perfil"
              className={
                "form-control" +
                (errors.nameDisability && touched.nameDisability
                  ? " is-invalid"
                  : "")
              }
            />
            <ErrorMessage
              name="nameDisability"
              component="div"
              className="invalid-feedback"
            />
          </div>

          <div className=" d-flex flex-sm-row flex-column-reverse justify-content-sm-around">
            <Button color="danger" type="reset" className="mt-3">
              Cancelar
            </Button>
            <Button color="success" type="submit" className="mt-2 mt-sm-3">
              Guardar
            </Button>
          </div>
          <FormikData info={data} />
        </Form>
      )}
    </Formik>
  );
};

const FormikData = ({ info }) => {
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    if (info) {
      setFieldValue("keyDisability", info[0]);
      setFieldValue("nameDisability", info[1]);
    }
  }, [info]);
  return null;
};

export default FormDiscapacidades;
